export default function (response) {
	const data = response && response.data !== undefined ? response.data : response;
	if (data === 'USER_EXISTS' || (data && data.message === 'USER_EXISTS')) {
		return 'El usuario ya existe';
	}
	if (data && typeof data.message === 'string') {
		return data.message;
	}
	if (data && typeof data === 'object') {
		const firstError = Object.keys(data).reduce((message, key) => {
			if (message) return message;
			const value = data[key];
			return Array.isArray(value) ? value[0] : value;
		}, '');
		if (typeof firstError === 'string' && firstError) return firstError;
	}
	return 'Verifique que completó los datos requeridos';
}



// WEBPACK FOOTER //
// ./src/http/errors.js